/*
* Generate fake-uuid to use as elements identifier
*/

const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
const uuid = () => `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`

export default uuid



// WEBPACK FOOTER //
// ./src/utils/uuid.js